<template>
  <NodeEditorial v-if="node?.__typename === 'NodeEditorial'" v-bind="node" />
  <NodeAccomodation
    v-else-if="node?.__typename === 'NodeAccomodation'"
    v-bind="node"
  />
  <NodePlace v-else-if="node?.__typename === 'NodePlace'" v-bind="node" />
  <NodeTour v-else-if="node?.__typename === 'NodeTour'" v-bind="node" />
  <div v-else />
</template>

<script lang="ts" setup>
// Yes, there needs to be an empty div in the template.

defineOptions({
  name: 'PageSlug',
})

definePageMeta({
  name: 'drupal-route',
  path: '/:slug(.*)*',
  languageMapping: {
    de: '/:slug(.*)*',
    fr: '/fr/:slug(.*)*',
    en: '/en/:slug(.*)*',
    it: '/it/:slug(.*)*',
  },
})

const { entity: node } = await useDrupalRouteQuery('all')
await renderPageDependencies()
</script>
